import { useEffect, useRef, useState } from 'react';

import { headingShownBefore, markHeadingShown, usePageTitle } from './pageTitle';

import type { ReactNode } from 'react';

export interface PageHeadingProps {
  children: ReactNode;
  /** Document title; defaults to the heading's text. */
  title?: string;
}

/** The page's `<h1>`: sets the document title and, after the first page, takes focus. */
export function PageHeading({ children, title }: PageHeadingProps) {
  const ref = useRef<HTMLHeadingElement>(null);
  const [takeFocus] = useState(headingShownBefore);
  usePageTitle(title ?? (typeof children === 'string' ? children : null));
  useEffect(() => {
    markHeadingShown();
    if (takeFocus) ref.current?.focus();
  }, [takeFocus]);
  return (
    <h1 ref={ref} tabIndex={-1} className="mb-4">
      {children}
    </h1>
  );
}
